import React from 'react'

import Icon from 'components/_old/Icon/Icon.jsx'

import './DateInput.css'

type DateInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const DateInput = ({ label, value, onChange, ...rest }: DateInputProps): JSX.Element => (
  <label className={`DateInput ${!value ? 'DateInput_empty' : ''}`}>
    <span className="DateInput-Label_top">{label}</span>
    <span className="DateInput-Label_full" aria-hidden="true">
      {label}
    </span>

    <input {...rest} type="date" onChange={onChange} value={value} className="DateInput-Input" />

    <Icon className="DateInput-Icon" type="date-picker" />
  </label>
)

export { DateInput }
